import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Autocomplete, Grid, TextField } from "@mui/material";

const useStyle = makeStyles({
    root: {
        margin: "2px"
    }
});
export default function InputFieldSelect(props) {
    const classes = useStyle();
    // PROPS
    const { id, options, label, variant, sm, md, value, onChange, renderOption, getOptionLabel, open, onOpen, onClose, loading } = props
    // VARIABLES DE ESTADO

    // FUNCIONES
    // VISTA
    /*{label !== undefined ? (
                    <InputLabel className={classes.labelRoot} color="primary">
                        {label}
                    </InputLabel>
) : null}*/
    return (
        <Grid item xs={12} sm={sm === null ? 12 : sm} md={md}>

            <Autocomplete
                p
                fullWidth
                className={classes.root}
                id={id}
                open={open}
                onOpen={onOpen}
                onClose={onClose}
                options={options}
                getOptionLabel={getOptionLabel}
                value={value}
                onChange={onChange}
                renderOption={renderOption}
                // style={{ width: 330 }}
                isOptionEqualToValue={(option, value) => option === value}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={label}
                        variant={variant}
                    />
                }
                loading={loading}
            />
        </Grid>
    )
}
InputFieldSelect.propTypes = {
    id: PropTypes.string,
    label: PropTypes.node,
    open: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    getOptionLabel: PropTypes.func,
    options: PropTypes.array,
    loading: PropTypes.bool,
    renderOption: PropTypes.func,
    sm: PropTypes.number,
    md: PropTypes.number
}